<template>
    <div class="row">
        <div class="col-12">
            <b-card class="shadow p-3">
                <div v-if="index === checklistLength">
                    <div class="row">
                        <div class="col-12">
                            <h6>{{trans('templates.checklists.completed')}}</h6>
                        </div>
                        <div class="col-12 text-center">
                            <b-img src="/images/master-dashboard/checklist_done.svg" fluid class="done-image"/>
                            <p class="mt-3">{{trans('templates.checklists.strength_text')}}</p>
                        </div>
                        <div class="col-12">
                            <hr/>
                            <b-button variant="outline-secondary" class="pull-right" @click="index--">
                                {{trans('global.review_your_answers')}}
                            </b-button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="d-flex justify-content-end mb-3">
                        <numbered-step
                            v-for="(c,i) in checklist"
                            :number="i+1"
                            :key="i"
                            :active="i <= index"
                        />
                    </div>
                    <h5 class="mb-4">{{currentTitle}}</h5>
                    <div v-for="(p,index) in currentPrompts" :key="index" v-if="currentPrompts">
                        <h5 class="mb-0">{{index+1}}.</h5>
                        <prompt-container
                            :prompt="p.prompt"
                            :type="p.prompt.type"
                            :prompt-id="p.prompt_id"
                            :page-id="pageId"
                            :module-id="moduleId"
                            :course-id="courseId"
                            :course-name="courseName"
                            :is-mission="isMission"
                            :key="p.prompt_id"
                            :is-augmented="isAugmented"
                            @updatePrompt="(data) => updatePrompt(data,index)"
                        />
                    </div>

                    <div class="row pt-3">
                        <div class="col-4">
                            <b-button variant="link" @click="index--" v-if="index > 0">{{trans('global.back')}}</b-button>
                        </div>
                        <div class="col-4 text-center">
                            <p class="text-small text-bold mb-0 mt-2">{{`${index+1}/${checklistLength}`}}</p>
                        </div>
                        <div class="col-4">
                            <b-button variant="secondary" class="pull-right" @click="index++" v-if="index < checklistLength">{{trans('global.next')}}</b-button>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
import PromptContainer from "../PromptContainer";
import NumberedStep from "../../../atoms/NumberedStep";

export default {
    name: "Checklist",
    components:{
        PromptContainer,
        NumberedStep
    },
    props:{
        header: Object,
        checklist: Array,
        pageId: String,
        moduleId: Number,
        courseId: Number,
        courseName: String,
        isMission: String,
        isAugmented: Boolean
    },
    data(){
        return {
            index: 0,
            userPrompts: this.checklist
        }
    },
    methods:{
        updatePrompt(data,index){
            this.currentPrompts[index].submission = data;
        }
    },
    computed:{
        checklistLength(){
            return this.userPrompts.length;
        },
        currentPrompts(){
            return this.userPrompts[this.index].data;
        },
        currentTitle(){
            return this.checklist[this.index].title;
        }
    }
}
</script>

<style scoped lang="scss">
.done-image{
    max-height: 200px;
}
</style>
